module.exports = __webpack_public_path__ + "img/2012-08-18 09.18.17.50d3ba93.jpg";